import { showElement } from '@local_modules/generic/dom/show-element.js'
import { syncManagementListeners } from './actions.js'

import htmlIndex from './index.html'

const containerId = 'organisationSyncManagement'

/**
 *
 * @param {*} organisationAccess
 */
export function showSyncManagement (accountingOrganisationId) {
  console.log('showSyncManagement', accountingOrganisationId)

  const containerElement = showElement(containerId)

  containerElement.innerHTML = htmlIndex

  containerElement.addEventListener('click', function (clickEvent) {
    syncManagementListeners(clickEvent, accountingOrganisationId)
  })
}
